export { SimpleDialog } from './SimpleDialog.tsx';
